<template>
  <h1>Authorized home</h1>
</template>

<script setup lang="ts">
import { useApi } from "@/.shared/.api/integration";
import { useAuthentication } from "@services/auth";
import { onMounted, ref } from "vue";

const auth = useAuthentication();
const api = useApi();

onMounted(async () => {
});
</script>